<template>
    <div id="app" class="app">
        <div id="app-loader" class="app-header">
            <div class="app-header-brand">
                <img class="loader-logo" alt="Vue logo" src="../../assets/logo.png">
                <font-awesome-icon :icon="['fas', 'spinner']" spin id="app-loader-icon" />
            </div>
        </div>
        <div class="app-main w-100"></div>
    </div>
</template>

<script>
    export default {
        name: 'app-loader'
    }
</script>
